import React from 'react';
import { CircularProgress } from '@material-ui/core';
import styled from 'styled-components';
import { Card, CardProps } from '../../../../ui-kit';

const FlexCard = styled(({ minHeight, ...other }: CardProps & PlaceholderProps) => <Card {...other} />)`
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    ${({ minHeight }) => `min-height: ${minHeight}px`}
`;

interface PlaceholderProps {
    minHeight?: number;
}

export const Placeholder: React.FC<PlaceholderProps> = ({ minHeight = 310 }) => {
    return (
        <FlexCard minHeight={minHeight}>
            <CircularProgress />
        </FlexCard>
    );
};
